// Vendor Libraries
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {set} from 'lodash';

// Components
import Button from '../core/button';

// Contexts
import {RouteContext} from '../../contexts/route-context';

function MediaItemNav({className, guid, label, route}) {
    return guid ? (
        <div className={classnames('mediaitem-nav', className)}>
            <RouteContext.Consumer>
                {({push}) => (
                    <Button
                        onClick={() => {
                            if (guid) {
                                push(`${route}/${guid}`);
                            }
                        }}
                    >
                        {label}
                    </Button>
                )}
            </RouteContext.Consumer>
        </div>
    ) : null;
}

MediaItemNav.propTypes = {
    className: PropTypes.string,
    guid: PropTypes.string,
    label: PropTypes.string,
    route: PropTypes.string.isRequired,
};

export default set(MediaItemNav, 'defaultProps', {
    label: 'Media Item Mapping',
});
